"use strict";

//Language
var url = window.location.href;
if (url.indexOf("/en/") !== -1) {
  var lang = "en";
} else {
  var lang = "de";
}

/*********************
 *      Concrete
 *********************/

//Concrete Parameters
let cType = parseInt($("#conType").val());
let fcd = Mat.Concrete.types[cType].fcd;
let epsC = []; // Array of the strain in the concrete over the height
let resolutionC = 50; //Resolution of the strain of concrete over the height
let ec1d = -2; // [promille]
let ec2d = -3; // [promille]

let Ec = Math.round(Math.pow(Mat.Concrete.types[cType].fcm, 1 / 3) * 10);

// Update concrete strenth from Dropdown Menu
$("#conType").change(function () {
  cType = parseInt($("#conType").val());
  fcd = Mat.Concrete.types[cType].fcd;
  Ec = Math.round(Math.pow(Mat.Concrete.types[cType].fcm, 1 / 3) * 10);
  $("#conFc").html(Mat.Concrete.types[cType].fck);
  $("#conFcd").html(Mat.Concrete.types[cType].fcd);
  $("#conFcm").html(Mat.Concrete.types[cType].fcm);
  $("#conFctm").html(Mat.Concrete.types[cType].fctm);
  $("#conEcm").html(Ec);
});

// Concrete Behavior
let idealPlastic;
let concBehaviour = parseInt($("#matBehavior").val()); //Behaviour of concrete under compression 0: Ideal Plastic; 1: Simplification c = 0.85x; 2: Concrete behavior according to SIA 262, 3: simple Handcalculations
if (concBehaviour == 0) {
  idealPlastic = true;
} else {
  idealPlastic = false;
}
let discription = [
  "Sowohl der Stahl als auch der Beton werden starr ideal plastisch modelliert. Die Dehnungen sind in diesem Fall streng genommen Dehnungsinkremente.",
  "Die Druckzone des Betons wird vereinfacht als rechteckig angenommen mit Spannungen von <i>f<sub>cd</sub></i> für Druckdehnungen über (1-0.85)*3‰=0.45‰. Dies entspricht einem Rechteckspannungsblock der Höhe 0.85*x für ε<i><sub>sup</sub></i> = -3‰.",
  "Die Druckzone des Betons wird exakt nach der Formel 28 der SIA 262 berechnet.",
  "Nur die Punkte (i) reiner Druck, (ii) x=d, (iii) x=h/2, (iv) reine Biegung und (v) reiner Zug werden berechnet.",
];

if (lang == "en") {
  discription = [
    "Both the steel and the concrete are modelled as perfectly plastic. The strains in this case are, strictly speaking, strain increments.",
    "The compression zone of the concrete is assumed to be rectangular with stresses of <i>f<sub>cd</sub></i> above compressive strains of (1-0.85)*3‰=0.45‰. This corresponds to a rectangular compression zone with a depth of 0.85*x for ε<i><sub>sup</sub></i> = -3‰.",
    "The compression zone of the concrete is calculated according to Formula 28 of the Swiss code SIA 262.",
    "Only the points (i) pure compression, (ii) x=d, (iii) x=h/2, (iv) pure bending and (v) pure tension are calculated.",
  ];
}

$("#matBehavior").change(function () {
  concBehaviour = parseInt($("#matBehavior").val());
  if (concBehaviour == 0) {
    idealPlastic = true;
  } else {
    idealPlastic = false;
  }
  $("#erklaerung").html(discription[concBehaviour]);
  // console.log(discription[concBehaviour]);
});

/*************************************************
 *      Function to check the changed Values
 *************************************************/
function alertMinMax(
  htmlString,
  value,
  minValue,
  maxValue,
  textString,
  minString,
  maxString
) {
  let exceedMaxMin = false;
  let alertString;
  if (value < minValue) {
    alertString =
      textString +
      " ist zu klein. Bitte wähle einen Wert zwischen " +
      minValue +
      " und " +
      maxValue +
      ".\n\n" +
      minString;
    if (lang == "en") {
      alertString =
        textString +
        " is too small. Pleas choose a value between " +
        minValue +
        " and " +
        maxValue +
        ".\n\n" +
        minString;
    }
    exceedMaxMin = true;
  } else if (value > maxValue) {
    alertString =
      textString +
      " ist zu gross. Bitte wähle einen Wert zwischen " +
      minValue +
      " und " +
      maxValue +
      ".\n\n" +
      maxString;
    if (lang == "en") {
      alertString =
        textString +
        " is too big. Pleas choose a value between " +
        minValue +
        " and " +
        maxValue +
        ".\n\n" +
        minString;
    }
    exceedMaxMin = true;
  } else if (isNaN(value)) {
    alertString = "Bitte eine Nummer eingeben.";
    if (lang == "en") {
      alertString = "Please insert a number.";
    }
    exceedMaxMin = true;
  }

  if (exceedMaxMin) {
    for (let i = 0; i < htmlString.length; i++) {
      document.getElementById(htmlString[i]).classList.add("is-invalid");
    }
    document.getElementById("Ctrl").classList.add("focus");
    alert(alertString);
    return exceedMaxMin;
  } else {
    for (let i = 0; i < htmlString.length; i++) {
      document.getElementById(htmlString[i]).classList.remove("is-invalid");
    }
    document.getElementById("Ctrl").classList.remove("focus");
  }
}

/***********************
 *       Geometry
 ***********************/

//Section Geometry
let height = parseInt($("#conH").val());
let width = parseInt($("#conB").val());
let Ac = height * width;

$("#conH").change(function () {
  height = parseInt($("#conH").val());
});
$("#conB").change(function () {
  width = parseInt($("#conB").val());
});
/************************
 *        Steel
 ************************/

const steelDiameter = [12, 16, 20, 22, 26];

//Steel Parameters
let fsd = 435;
let Es = 205;
let epsSmax = fsd / Es;
let epsSTop, epsSBot;

//Steel Geometry
let dShear = 10; //Diameter of shear rebars
let cNom = parseInt($("#cNom").val());
let dRebar = steelDiameter[parseInt($("#dRebar").val())]; //Steel Diameter

let dTop = cNom + dShear + dRebar / 2; // Lever for Top Steel Layer
let dBot = height - cNom - dShear - dRebar / 2; // Lever for Lower Steel Layer

let dSide = cNom + dShear + dRebar / 2; // Distance of Rebard from the side

let nRebar = parseInt($("#nRebar").val()) + 2; // Number of Rebars per Layer

let AsTop = ((nRebar * dRebar * dRebar) / 4) * math.pi;
let AsBot = ((nRebar * dRebar * dRebar) / 4) * math.pi;

/*************
 *
 * @param (integer) diameter
 * @param (number)  d
 * @param (number)  n
 * @constructor
 ***************************/
function Reinforcement(diameter, d, n) {
  this.diameter = diameter; // Diameter of the Rebar [mm]
  this.dLever = d; // Lever of the rebar measured from top [mm]
  this.N = n; // Force acting on the rebar [N]
  this.As = (Math.pow(this.diameter, 2) * Math.PI) / 4; // Area of Rebar [mm2]
  this.stress = n / this.As; // Stress in the Rebar [MPa]
}

var steelTop = new Reinforcement(
  dRebar,
  dTop,
  Math.floor(-AsTop * (fsd - fcd))
);

var steelBot = new Reinforcement(
  dRebar,
  dBot,
  Math.floor(-AsBot * (fsd - fcd))
);

// Change number of rebars
$("#nRebar").change(function () {
  nRebar = parseInt($("#nRebar").val()) + 2;
});

// Change diameter of rebars
$("#dRebar").change(function () {
  dRebar = steelDiameter[parseInt($("#dRebar").val())];
});
// Change cnom
$("#cNom").change(function () {
  cNom = parseInt($("#cNom").val());
});

/*****************
 * Force Slider
 *****************/

var forceSlider = document.getElementById("Force");

function filterPips(value, type) {
  let pipsLarge =
    Math.round(
      (-Math.floor((-Ac * fcd - (AsTop + AsBot) * (fsd - fcd)) / 1000) +
        Math.floor(((AsTop + AsBot) * fsd) / 1000)) /
        1000
    ) * 100;
  let pipsSmall = pipsLarge / 5;

  if (window.checkMobile() == true) {
    pipsLarge = pipsLarge * 2;
    pipsSmall = pipsLarge / 5;
  }

  if (value % pipsLarge === 0) {
    return 1;
  } else if (value % pipsSmall == 0 && value % pipsLarge != 0) {
    return 0;
  } else {
    return -1;
  }
}

noUiSlider.create(forceSlider, {
  start: [Math.floor((-Ac * fcd - (AsTop + AsBot) * (fsd - fcd)) / 1000)],
  range: {
    min: Math.floor((-Ac * fcd - (AsTop + AsBot) * (fsd - fcd)) / 1000),
    max: Math.floor(((AsTop + AsBot) * fsd) / 1000),
  },
  //tooltips: true,
  step: 1,
  pips: {
    mode: "steps",
    filter: filterPips,
  },

  tooltips: [
    {
      to: function (value) {
        return Math.round(parseInt(value));
      },
    },
  ],
  // format: {
  //     to: function(value){
  //         return Math.round(value*10)/10;
  //     },
  //     from: function(value){
  //         return value;
  //     }
  // }
});

// Update the Force value when the slider was moved
function adjustSlider() {
  //console.log('In function adjustSlider: '+NSlider+' '+MSlider);
  let max = Math.floor(((AsTop + AsBot) * fsd) / 1000);
  let min = Math.floor((-Ac * fcd - (AsTop + AsBot) * (fsd - fcd)) / 1000);

  let tempSlider = findSliderValues();
  let MSlider = tempSlider[1];
  let NSlider = tempSlider[0];
  // console.log('In function adjustSlider: '+NSlider+' '+MSlider);

  if (NSlider < min) {
    NSlider = min;
  }
  if (NSlider > max) {
    NSlider = max;
  }

  if (concBehaviour == 3) {
    let ranger = {};
    ranger["min"] = [min];
    ranger[((Nhand[1] - min) / (max - min)) * 100 + "%"] = [Nhand[1]];
    ranger[((Nhand[2] - min) / (max - min)) * 100 + "%"] = [Nhand[2]];

    ranger[((-min / (max - min)) * 100).toString() + "%"] = [Nhand[3]];
    ranger["max"] = [max];

    // ranger = [min.toString(), Nhand[1].toString(), Nhand[2].toString(), Nhand[3].toString(), max.toString() ],
    forceSlider.noUiSlider.updateOptions({
      snap: true,
      range: ranger,
      pips: {
        mode: "range",
        density: 5,
      },
    });
  } else if (concBehaviour == 0) {
    let ranger = {};
    // ranger['min']= [min];
    // ranger[((NIdealPl[0]-min)/(max-min)*100)+'%'] = [NIdealPl[0]];
    // ranger[((NIdealPl[1]-min)/(max-min)*100)+'%'] = [NIdealPl[1]];
    // ranger[((NIdealPl[2]-min)/(max-min)*100)+'%'] = [NIdealPl[2]];
    // ranger[((NIdealPl[3]-min)/(max-min)*100)+'%'] = [NIdealPl[3]];
    // ranger['max'] = [max];

    let rangerDetailed = math.range(min, max, 1);
    let nForce;
    ranger["min"] = [min];
    //console.log(NIdealPl);
    for (let i = 0; i < rangerDetailed._data.length; i++) {
      nForce = min + i;
      if (
        nForce < NIdealPl[0] ||
        (nForce >= NIdealPl[1] && nForce < NIdealPl[3]) ||
        nForce > NIdealPl[2]
      ) {
        ranger[((nForce - min) / (max - min)) * 100 + "%"] = [nForce];
      }
    }
    ranger["max"] = [max];

    forceSlider.noUiSlider.updateOptions({
      snap: true,
      range: ranger,
      pips: {
        mode: "range",
        filter: filterPips,
      },
    });
  } else {
    forceSlider.noUiSlider.updateOptions({
      snap: false,
      range: {
        min: min,
        max: max,
      },
      pips: {
        mode: "steps",
        filter: filterPips,
      },
    });
  }

  forceSlider.noUiSlider.set(NSlider);

  tempSlider = findSliderValues();
  MSlider = tempSlider[1];
  NSlider = tempSlider[0];
  // console.log('In function adjustSlider - AFTER: '+NSlider+' '+MSlider);
}

function findSliderValues() {
  let NSlider = forceSlider.noUiSlider.get();
  let tempSlider = chatchI(NSlider);
  let MSlider = tempSlider[4];
  NSlider = tempSlider[5];
  // console.log('In function findSliderValues: '+NSlider+' '+MSlider);

  return [NSlider, MSlider];
}

// Update the position of the point
function updatePoint(N, M) {
  //console.log(N+'   '+M);
  var update = {
    x: [[M]],
    y: [[N]],
  };
  Plotly.restyle("plotMNInteraktion", update, [2]);
}

/***************************
 *     Update Classes
 ***************************/
let acceptAllValues;
// Update Calculation when parameters where changed
$(".updCalc").change(function () {
  //fc = parseInt($("#conFc").val());
  acceptAllValues = true;
  mnInteraktionDetailed(false);
  if (acceptAllValues) {
    adjustSlider();
    let tempSlider = findSliderValues();
    let NSlider = tempSlider[0];
    let MSlider = tempSlider[1];
    // console.log('In function updCalc: '+NSlider+' '+MSlider);
    updatePoint(NSlider, MSlider);
  }
});

// Update calculations and Drawings of Sections
$(".updAll").change(function () {
  dTop = cNom + dShear + dRebar / 2;
  dBot = height - cNom - dShear - dRebar / 2;
  dSide = cNom + dShear + dRebar / 2;

  acceptAllValues = true;
  mnInteraktionDetailed(true);
  if (acceptAllValues) {
    let tempSlider = findSliderValues();
    let NSlider = tempSlider[0];
    let MSlider = tempSlider[1];
    // console.log('In function updAll: '+NSlider+' '+MSlider);
    adjustSlider();
    updatePoint(NSlider, MSlider);
  }
});

/***************************
 *     Main Calculations
 ***************************/

// Configuration for Plotly
var config = pltConfig;

// Forces and Levers
let Nc;
let NsTop = [];
let NsBot = [];
var Nd = [];
var Md = [];
let x = []; // Position of the Neutral Axis
let c = []; // Height of compression Zone
let x045; //Height where the strain in  the concrete is -0.45promille
let epsC0; //Strain of concrete at the lowest point in the section

let Nhand = [];
let Mhand = [];
let position = [];

let NIdealPl = [];
let MIdealPl = [];

// Selected Force
let Nactive;

// Calculation Steps
let i, ii;

var NdOld, MdOld;

let Xi, Xi1, XiCrit;
let init = 0;

let resolution = 1000; //Incremental Steps of Chi

//Variable needed for the Concrete Behavior according to SIA 262
let concreteSIAdata;
let NcParabel;
let NcRest;
let leverCRest;
let leverCParabel;
let Mc;
/**********
 *
 * @constructor Main function calculation the M-N-Diagram
 */
function mnInteraktionDetailed(plotQSBool) {
  // $( ".slider" ).slider( "enable" );
  forceSlider.removeAttribute("disabled");

  // Check the given Values
  let acceptValue = false;
  let errormsg = "Die Höhe h";
  if (lang == "en") {
    errormsg = "The height h";
  }
  acceptValue = alertMinMax(["conH"], height, 200, 800, errormsg, "", "");
  if (acceptValue) {
    acceptAllValues = false;
    return;
  }
  errormsg = "Die Breite b";
  if (lang == "en") {
    errormsg = "The width b";
  }
  acceptValue = alertMinMax(["conB"], width, 300, 10000, errormsg, "", "");
  if (acceptValue) {
    acceptAllValues = false;
    return;
  }
  errormsg = "Die Betonüberdeckung ";
  if (lang == "en") {
    errormsg = "The concrete cover ";
  }
  acceptValue = alertMinMax(["cNom"], cNom, 10, 50, errormsg, "", "");
  if (acceptValue) {
    acceptAllValues = false;
    return;
  }

  AsTop = ((nRebar * dRebar * dRebar) / 4) * math.pi;
  AsBot = ((nRebar * dRebar * dRebar) / 4) * math.pi;

  $("#dTop").html(Math.round(dTop));
  $("#dBot").html(Math.round(dBot));
  $("#AsTop").html(Math.round(AsTop));
  $("#AsBot").html(Math.round(AsBot));

  Ac = height * width;

  XiCrit = (fsd / Es - ec2d) / dBot;

  Xi1 = math.range(0, XiCrit, XiCrit / (resolution - 0.00001));

  ii = 0;
  while (Xi1._data[ii] < XiCrit) {
    Xi = Xi1._data[ii];

    if (Xi == 0) {
      // Reiner Druck
      c[ii] = height;
      x[ii] = "PurePressure";
      NsTop[ii] = -fsd * AsTop;
      NsBot[ii] = -fsd * AsBot;
      Nd[ii] = (-Ac * fcd - (AsTop + AsBot) * (fsd - fcd)) / 1000;
      Md[ii] = 0;
    } else {
      x[ii] = -ec2d / Xi;
      epsSTop = -Xi * (x[ii] - dTop);
      epsSBot = -Xi * (x[ii] - dBot);

      // Concrete under Compression
      if (concBehaviour == 0) {
        c[ii] = math.min(x[ii], height);
        Nc = -c[ii] * width * fcd;
        Mc = (height / 2 - c[ii] / 2) * -Nc;
      } else if (concBehaviour == 1 || concBehaviour == 3) {
        c[ii] = math.min(0.85 * x[ii], height);
        Nc = -c[ii] * width * fcd;
        Mc = (height / 2 - c[ii] / 2) * -Nc;
      } else if (concBehaviour == 2) {
        epsC0 = math.min(0, -Xi * (x[ii] - height)); // Strain at the lowest compression point of the crosssection
        if (epsC0 > ec1d) {
          concreteSIAdata = concreteSIA262(epsC0, ec1d);
          NcParabel = concreteSIAdata[0] / Xi;
          NcRest = -fcd * width * (x[ii] + ec1d / Xi);
          leverCRest = height / 2 - (x[ii] + ec1d / Xi) / 2;
          leverCParabel = x[ii] + concreteSIAdata[1] / Xi - height / 2;
          Nc = NcParabel + NcRest;
          Mc = -NcRest * leverCRest + NcParabel * leverCParabel;
          c[ii] = math.min(0.85 * x[ii], height);
        } else {
          c[ii] = height;
          Nc = -c[ii] * width * fcd;
          Mc = (height / 2 - c[ii] / 2) * -Nc;
        }
      } else {
        if (lang == "en") {
          alert("Error in the behaviour of concrete");
        } else {
          alert("Fehler bei Verhalten von Beton");
        }
      }

      //Upper Steel Layer
      if (math.abs(epsSTop) < epsSmax && idealPlastic === false) {
        if (epsSTop < 0) {
          NsTop[ii] = epsSTop * Es * AsTop;
          Nc = Nc + AsTop * fcd;
          Mc = Mc - AsTop * fcd * (height / 2 - dTop);
        } else {
          NsTop[ii] = epsSTop * Es * AsTop;
        }
      } else {
        if (epsSTop < 0) {
          NsTop[ii] = -fsd * AsTop;
          Nc = Nc + AsTop * fcd;
          Mc = Mc - AsTop * fcd * (height / 2 - dTop);
        } else {
          NsTop[ii] = fsd * AsTop;
        }
      }

      // Lower Steel Layer
      if (math.abs(epsSBot) < epsSmax && idealPlastic === false) {
        if (epsSBot < 0) {
          NsBot[ii] = epsSBot * Es * AsBot;
          Nc = Nc + AsBot * fcd;
          Mc = Mc - AsBot * fcd * (height / 2 - dBot);
        } else {
          NsBot[ii] = epsSBot * Es * AsBot;
        }
      } else {
        if (epsSBot < 0) {
          NsBot[ii] = -fsd * AsBot;
          Nc = Nc + AsBot * fcd;
          Mc = Mc - AsBot * fcd * (height / 2 - dBot);
        } else {
          NsBot[ii] = fsd * AsBot;
        }
      }
      Nd[ii] = (Nc + NsTop[ii] + NsBot[ii]) / 1000;
      Md[ii] =
        (Mc +
          (height / 2 - dTop) * -NsTop[ii] +
          (dBot - height / 2) * NsBot[ii]) /
        1000000;
      //console.log('Nd: '+Nd[ii]+' Md: '+Md[ii]);
    }
    ii++;
  }

  //Steel strain fixed
  let length = ii;
  let jj = 0;
  ii--;
  while (Xi1._data[ii] >= 0) {
    Xi = Xi1._data[ii];

    // Pure Tension
    if (Xi == 0) {
      c[length - 1 + jj] = 0;
      x[length - 1 + jj] = "PureTension";
      NsTop[length - 1 + jj] = AsTop * fsd;
      NsBot[length - 1 + jj] = AsBot * fsd;
      Nd[length - 1 + jj] = ((AsTop + AsBot) * fsd) / 1000;
      Md[length - 1 + jj] = 0;
    } else {
      // Concrete Pressure
      epsC = -Xi * dBot + epsSmax;
      x[length - 1 + jj] = dBot - epsSmax / Xi;

      // Concrete under Compression
      if (concBehaviour == 0) {
        c[length - 1 + jj] = Math.max(0, x[length - 1 + jj]);
        Nc = -c[length - 1 + jj] * fcd * width;
        Mc = (height / 2 - c[length - 1 + jj] / 2) * -Nc;
      } else if (concBehaviour == 1 || concBehaviour == 3) {
        x045 = (0.45 / epsSmax) * (dBot - x[length - 1 + jj]);
        c[length - 1 + jj] = Math.max(0, x[length - 1 + jj] - x045);
        Nc = -c[length - 1 + jj] * fcd * width;
        Mc = (height / 2 - c[length - 1 + jj] / 2) * -Nc;
      } else if (concBehaviour == 2) {
        let epsCTop = math.min(-Xi * dBot + epsSmax, 0);
        if (epsCTop <= -2) {
          concreteSIAdata = concreteSIA262(0, ec1d);
          NcParabel = concreteSIAdata[0] / Xi;
          NcRest = -fcd * width * (x[length - 1 + jj] + ec1d / Xi);

          leverCRest = height / 2 - (x[length - 1 + jj] + ec1d / Xi) / 2;
          leverCParabel =
            x[length - 1 + jj] + concreteSIAdata[1] / Xi - height / 2;
          Nc = NcParabel + NcRest;
          Mc = -NcRest * leverCRest + NcParabel * leverCParabel;
          c[length - 1 + jj] = math.max(0.85 * x[length - 1 + jj], 0);
        } else if (epsCTop > -2 && epsCTop < 0) {
          concreteSIAdata = concreteSIA262(0, epsCTop);
          NcParabel = concreteSIAdata[0] / Xi;
          NcRest = -fcd * width * (x[length - 1 + jj] + epsCTop / Xi);

          leverCRest = height / 2 - (x[length - 1 + jj] + epsCTop / Xi) / 2;
          leverCParabel =
            x[length - 1 + jj] + concreteSIAdata[1] / Xi - height / 2;
          Nc = NcParabel + NcRest;
          Mc = -NcRest * leverCRest + NcParabel * leverCParabel;
          c[length - 1 + jj] = math.max(0.85 * x[length - 1 + jj], 0);
        } else if (epsCTop == 0) {
          c[length - 1 + jj] = 0;
          Nc = 0;
        } else {
          if (lang == "en") {
            alert("Error with concrete strains.");
          } else {
            alert("Fehler bei Beton Dehnungen.");
          }
        }
      } else {
        if (lang == "en") {
          alert("Error in the behaviour of concrete");
        } else {
          alert("Fehler bei Verhalten von Beton");
        }
      }

      // Steel Top Layer
      epsSTop = -Xi * (dBot - dTop) + epsSmax;
      if (math.abs(epsSTop) < epsSmax && idealPlastic == false) {
        if (epsSTop < 0) {
          NsTop[length - 1 + jj] = epsSTop * Es * AsTop;
          Nc = Nc + AsTop * fcd;
          Mc = Mc - AsTop * fcd * (height / 2 - dTop);
          //Mc = Mc - AsTop*fcd*
        } else {
          NsTop[length - 1 + jj] = epsSTop * Es * AsTop;
        }
      } else {
        if (epsSTop < 0) {
          NsTop[length - 1 + jj] = -fsd * AsTop;
          Nc = Nc + AsTop * fcd;
          Mc = Mc - AsTop * fcd * (height / 2 - dTop);
        } else {
          NsTop[length - 1 + jj] = fsd * AsTop;
        }
      }

      // Steel bottom Layer
      NsBot[length - 1 + jj] = AsBot * fsd;

      Nd[length - 1 + jj] =
        (Nc + NsTop[length - 1 + jj] + NsBot[length - 1 + jj]) / 1000;
      Md[length - 1 + jj] =
        (Mc +
          (height / 2 - dTop) * -NsTop[length - 1 + jj] +
          (dBot - height / 2) * NsBot[length - 1 + jj]) /
        1000000;
    }
    jj++;
    ii--;
  }

  // Simulate simple Handcalculation
  if (concBehaviour == 3) {
    for (i = 0; i < Nd.length; i++) {
      if (x[i] == "PurePressure") {
        position[0] = i;
        Nhand[0] = Nd[i];
        Mhand[0] = Md[i];
      }
      if (Math.abs(x[i] - dBot) < 1) {
        position[1] = i;
        x[i] = dBot;
        Xi1._data[i] = Math.abs(ec2d / dBot);
        epsSTop = -Xi1._data[i] * (x[i] - dTop);
        epsSBot = -Xi1._data[i] * (x[i] - dBot);
        if (math.abs(epsSTop) < epsSmax) {
          NsTop[i] = AsTop * epsSTop * Es;
        } else {
          NsTop[i] = AsTop * fsd;
        }
        NsBot[i] = AsBot * epsSBot * Es;
        Nhand[1] =
          (0.85 * x[i] * fcd * width + Math.abs(NsTop[i]) - AsTop * fcd) /
          -1000;
        Mhand[1] =
          (0.85 * x[i] * fcd * width * (height / 2 - (0.85 * x[i]) / 2) +
            (Math.abs(NsTop[i]) - AsTop * fcd) * (height / 2 - dTop)) /
          1000000;
      }
      if (Math.abs(x[i] - height / 2) < 1) {
        position[2] = i;
        x[i] = height / 2;
        Xi1._data[i] = Math.abs(ec2d / (height / 2));
        epsSTop = -Xi1._data[i] * (x[i] - dTop);
        epsSBot = -Xi1._data[i] * (x[i] - dBot);
        if (math.abs(epsSTop) < epsSmax) {
          NsTop[i] = AsTop * epsSTop * Es;
        } else {
          NsTop[i] = AsTop * fsd;
        }
        if (math.abs(epsSBot) < epsSmax) {
          NsBot[i] = AsBot * epsSBot * Es;
        } else {
          NsBot[i] = AsBot * fsd;
        }
        Nhand[2] =
          (0.85 * x[i] * fcd * width +
            Math.abs(NsTop[i]) -
            AsTop * fcd -
            NsBot[i]) /
          -1000;
        Mhand[2] =
          (0.85 * x[i] * fcd * width * (height / 2 - (0.85 * x[i]) / 2) +
            (Math.abs(NsTop[i]) - AsTop * fcd) * (height / 2 - dTop) +
            NsBot[i] * (dBot - height / 2)) /
          1000000;
      }
      if (Nd[i] < 0 && Nd[i + 1] > 0) {
        position[3] = i;
        Nhand[3] = 0;
        Mhand[3] = Md[i];
        Nd[i] = 0;
      }
      if (x[i] == "PureTension") {
        position[4] = i;
        Nhand[4] = Nd[i];
        Mhand[4] = Md[i];
      }
    }
    // console.log(position);
  }
  // Calculation the points where the steelstress is changing

  if (concBehaviour == 0) {
    NIdealPl[0] =
      (-(AsTop + AsBot) * fsd - (dBot * width - AsTop) * fcd) / 1000;
    NIdealPl[1] = ((AsTop - AsBot) * fsd - (dBot * width - AsTop) * fcd) / 1000;
    NIdealPl[2] = ((AsBot + AsTop) * fsd - dTop * width * fcd) / 1000;
    NIdealPl[3] = ((AsBot - AsTop) * fsd - dTop * width * fcd) / 1000;

    MIdealPl[0] =
      (dBot * width * fcd * (height / 2 - dBot / 2) -
        AsTop * fcd * (height / 2 - dTop) +
        (height / 2 - dTop) * AsTop * fsd -
        (dBot - height / 2) * AsBot * fsd) /
      1000000;
    MIdealPl[1] =
      (dBot * width * fcd * (height / 2 - dBot / 2) -
        AsTop * fcd * (height / 2 - dTop) +
        (height / 2 - dTop) * AsTop * fsd +
        (dBot - height / 2) * AsBot * fsd) /
      1000000;
    MIdealPl[3] =
      (dTop * width * fcd * (height / 2 - dTop / 2) +
        (height / 2 - dTop) * AsTop * fsd +
        (dBot - height / 2) * AsBot * fsd) /
      1000000;
    MIdealPl[2] =
      (dTop * width * fcd * (height / 2 - dTop / 2) -
        (height / 2 - dTop) * AsTop * fsd +
        (dBot - height / 2) * AsBot * fsd) /
      1000000;
  }

  errormsg = "Vorherig";
  if (lang == "en") {
    errormsg = "Previous";
  }
  let trace0 = {
    x: MdOld,
    y: NdOld,
    mode: "lines",
    line: {
      width: 1,
      color: "rgb(200,200,250)",
      // dash: 'dash',
    },
    name: errormsg,
  };

  let trace1;
  if (concBehaviour == 3) {
    errormsg = "Neu";
    if (lang == "en") {
      errormsg = "New";
    }
    trace1 = {
      x: Mhand,
      y: Nhand,
      mode: "lines",
      line: {
        width: 1,
        color: "rgb(50,50,200)",
        //dash: 'dash',
      },
      name: errormsg,
    };
  } else {
    errormsg = "Neu";
    if (lang == "en") {
      errormsg = "New";
    }
    trace1 = {
      x: Md,
      y: Nd,
      mode: "lines",
      line: {
        width: 1,
        color: "rgb(50,50,200)",
        //dash: 'dash',
      },
      name: errormsg,
    };
  }

  //Point on Graph
  let tempSlider = findSliderValues();
  let NSlider = tempSlider[0];
  let MSlider = tempSlider[1];
  // console.log('In main function: '+NSlider+' '+MSlider);

  var trace2 = {
    x: [MSlider],
    y: [NSlider],
    mode: "marker",
    marker: {
      size: 7,
      color: "rgb(1,0,0)",
    },
    showlegend: false,
  };

  let data = [trace0, trace1, trace2];

  if (concBehaviour == 0) {
    let trace3 = [
      {
        x: [MIdealPl[0], MIdealPl[1]],
        y: [NIdealPl[0], NIdealPl[1]],
        mode: "lines",
        line: {
          width: 1,
          color: "rgb(255,255,255)",
          dash: "dash",
        },
        showlegend: false,
      },
      {
        x: [MIdealPl[2], MIdealPl[3]],
        y: [NIdealPl[2], NIdealPl[3]],
        mode: "lines",
        line: {
          width: 1,
          color: "rgb(255,255,255)",
          dash: "dash",
        },
        showlegend: false,
      },
    ];
    data.push(...trace3);
  }

  let layout = {
    hovermode: false,
    height: 400,
    margin: {
      r: 20,
      l: 80,
      t: 10,
      b: 40,
    },
    xaxis: {
      domain: [0, 1],
      title: "M<sub>Rd</sub>[kNm]",
      range: [-20, Math.max(...Md) + 20],
      //autorange: true,
    },
    yaxis: {
      title: "N<sub>Rd</sub>[kN]",
      range: [Nd[2 * resolution - 2] + 100, Nd[0] - 100],
      autorage: true,
    },
    showlegend: true,
  };

  Plotly.react("plotMNInteraktion", data, layout, config);

  if (concBehaviour == 3) {
    NdOld = Nhand.slice();
    MdOld = Mhand.slice();
  } else {
    NdOld = Nd.slice();
    MdOld = Md.slice();
  }

  if (plotQSBool) {
    plotQuschnitt();
  }
}

/**********************************
 *      Plotting of the Section
 **********************************/
//Querschnitt

function plotQuschnitt() {
  // Section
  let tempSec = new Group();
  tempSec.addElm(
    new Rectangle(width, height, width / 2, height / 2).setFill(
      col.c_vis.getRgb()
    )
  );
  //Rebars
  for (let i = 1; i < nRebar + 1; i++) {
    tempSec.addElm(
      new Circle(
        dSide + ((i - 1) * (width - 2 * dSide)) / (nRebar - 1),
        height - dTop,
        dRebar / 2
      ).setFill(col.base.getRgb())
    );
    tempSec.addElm(
      new Circle(
        dSide + ((i - 1) * (width - 2 * dSide)) / (nRebar - 1),
        height - dBot,
        dRebar / 2
      ).setFill(col.base.getRgb())
    );
  }
  let pltSec = tempSec.getPlotData();

  //Shear Reinforcement in the Crosssection
  let tempShear = new Group();
  tempShear.addElm(
    new Circle(dSide, height - dBot, dRebar / 2 + dShear, 90).rotate(
      180,
      dSide,
      height - dBot
    )
  );
  tempShear.addElm(
    new Circle(dSide, height - dTop, dRebar / 2 + dShear, 90).rotate(
      90,
      dSide,
      height - dTop
    )
  );
  tempShear.addElm(
    new Circle(width - dSide, height - dBot, dRebar / 2 + dShear, 90).rotate(
      270,
      width - dSide,
      height - dBot
    )
  );
  tempShear.addElm(
    new Circle(width - dSide, height - dTop, dRebar / 2 + dShear, 90).rotate(
      0,
      width - dSide,
      height - dTop
    )
  );
  tempShear.addElm(
    new Line(
      [dSide - dRebar / 2 - dShear, dSide - dRebar / 2 - dShear],
      [height - dBot, height - dTop]
    )
  );
  tempShear.addElm(
    new Line(
      [dSide - dRebar / 2, dSide - dRebar / 2],
      [height - dBot, height - dTop]
    )
  );
  tempShear.addElm(
    new Line(
      [
        width - dSide + dRebar / 2 + dShear,
        width - dSide + dRebar / 2 + dShear,
      ],
      [height - dBot, height - dTop]
    )
  );
  tempShear.addElm(
    new Line(
      [width - dSide + dRebar / 2, width - dSide + dRebar / 2],
      [height - dBot, height - dTop]
    )
  );
  tempShear.addElm(
    new Line(
      [dSide, width - dSide],
      [height - dBot - dRebar / 2, height - dBot - dRebar / 2]
    )
  );
  tempShear.addElm(
    new Line(
      [dSide, width - dSide],
      [height - dBot - dRebar / 2 - dShear, height - dBot - dRebar / 2 - dShear]
    )
  );
  tempShear.addElm(
    new Line(
      [dSide, width - dSide],
      [height - dTop + dRebar / 2, height - dTop + dRebar / 2]
    )
  );
  tempShear.addElm(
    new Line(
      [dSide, width - dSide],
      [height - dTop + dRebar / 2 + dShear, height - dTop + dRebar / 2 + dShear]
    )
  );

  if (nRebar > 3) {
    let nAdjust;
    if (nRebar == 4 || nRebar == 5) {
      nAdjust = 3;
    } else {
      nAdjust = 4;
    }
    let dInside = ((nRebar - nAdjust) * (width - 2 * dSide)) / (nRebar - 1);
    //console.log(dInside)
    tempShear.addElm(
      new Circle(
        dSide + dInside,
        height - dBot,
        dRebar / 2 + dShear,
        90
      ).rotate(180, dSide + dInside, height - dBot)
    );
    tempShear.addElm(
      new Circle(
        dSide + dInside,
        height - dTop,
        dRebar / 2 + dShear,
        90
      ).rotate(90, dSide + dInside, height - dTop)
    );
    tempShear.addElm(
      new Circle(
        width - dSide - dInside,
        height - dBot,
        dRebar / 2 + dShear,
        90
      ).rotate(270, width - dSide - dInside, height - dBot)
    );
    tempShear.addElm(
      new Circle(
        width - dSide - dInside,
        height - dTop,
        dRebar / 2 + dShear,
        90
      ).rotate(0, width - dSide - dInside, height - dTop)
    );
    tempShear.addElm(
      new Line(
        [
          dSide - dRebar / 2 - dShear + dInside,
          dSide - dRebar / 2 - dShear + dInside,
        ],
        [height - dBot, height - dTop]
      )
    );
    tempShear.addElm(
      new Line(
        [dSide - dRebar / 2 + dInside, dSide - dRebar / 2 + dInside],
        [height - dBot, height - dTop]
      )
    );
    tempShear.addElm(
      new Line(
        [
          width - dSide + dRebar / 2 + dShear - dInside,
          width - dSide + dRebar / 2 + dShear - dInside,
        ],
        [height - dBot, height - dTop]
      )
    );
    tempShear.addElm(
      new Line(
        [
          width - dSide + dRebar / 2 - dInside,
          width - dSide + dRebar / 2 - dInside,
        ],
        [height - dBot, height - dTop]
      )
    );
    tempShear.addElm(
      new Line(
        [dSide, width - dSide],
        [height - dBot - dRebar / 2, height - dBot - dRebar / 2]
      )
    );
    tempShear.addElm(
      new Line(
        [dSide, width - dSide],
        [
          height - dBot - dRebar / 2 - dShear,
          height - dBot - dRebar / 2 - dShear,
        ]
      )
    );
    tempShear.addElm(
      new Line(
        [dSide, width - dSide],
        [height - dTop + dRebar / 2, height - dTop + dRebar / 2]
      )
    );
    tempShear.addElm(
      new Line(
        [dSide, width - dSide],
        [
          height - dTop + dRebar / 2 + dShear,
          height - dTop + dRebar / 2 + dShear,
        ]
      )
    );
  }
  let pltShear = tempShear.getPlotData();

  // Dimensioning Lines
  let offset = Math.sqrt((height * width) / 30);
  let offsetText = Math.sqrt((height * width) / (25 * 50));
  let r = 4;
  let tempDim = new Group();
  //tempDim.addElm(new DimLine([0,height],[0,height-dBot],'d', offset,r));
  tempDim.addElm(
    new DimLine([width, height], [width, 0], "h", r, 1.5 * offset, offsetText)
  );
  tempDim.addElm(
    new DimLine(
      [width, height],
      [width, height - dTop],
      "d<sub>sup</sub>",
      r,
      offset / 2,
      offsetText
    )
  );
  tempDim.addElm(
    new DimLine(
      [0, height],
      [0, height - dBot],
      "d<sub>inf</sub>",
      r,
      -offset,
      offsetText
    )
  );
  tempDim.addElm(
    new DimLine([0, 0], [width, 0], "b", r, -offset / 1.5, offsetText)
  );

  let pltDim = tempDim.getPlotData();

  // Acting Forces
  let layout = {
    hovermode: false,
    height: 400,
    margin: {
      r: 0,
      l: 10,
      t: 10,
      b: 40,
    },

    xaxis: {
      // title: 'M<sub>Rd</sub>[kNm]',
      range: [-2 * offset, width + 2.5 * offset], //width+distance+lengthSide+10],
      zeroline: false,
      showgrid: false,
      showline: false,
      showticklabels: false,
      //fixedrange: true,
    },
    yaxis: {
      autorange: true,
      zeroline: false,
      showgrid: false,
      showline: false,
      showticklabels: false,
      scaleanchor: "x",
      //fixedrange: true,
    },
    showlegend: false,
  };

  var data = pltSec.data;
  data.push(...pltShear.data);
  data.push(...pltDim.data);

  if (window.checkMobile() == true) {
    layout.dragmode = false;
  }

  Plotly.react("plotQS", data, layout, config);
}

/***********************************
 *      Stress and Strain Diagrams
 ***********************************/
/******
 *
 * @param (integer) heightSec   Height of the section in [mm]
 * @param (struct) steel1       Struct for upper steel rebars
 * @param (struct) steel2       Struct for lower steel rebars
 * @param (number)  chi         Flexion of crosssection [-]
 * @param (number)  x           Height of compressionzone [mm]
 * @param (integer) fcdConc     fcd of the concrete [MPa]
 */

/*******************
 *  Stress And Srtain with drawLib
 ******************/
function plotStressStrain(
  heightSec,
  steel1,
  steel2,
  chi,
  xComp,
  cComp,
  fcdConc,
  N
) {
  let scalingStrain = height / 20; // Up Scaling Factor for Strain
  let scalingConcStress = 250 / height; // Down Scaling factor for concrete stresses
  let scalingSteelStress = 10000 / height; // Down Scaling factor for steel Stresses
  let scalingForce = 350;
  //console.log('Chi: '+chi);
  chi = chi * scalingStrain;

  let offsetVariable = height / 25; // Offset of the variables depending on the height

  /***************
   *  Strain
   ***************/
  let xStrain = 5;

  //Differ between pure pressure/tension and other cases
  let offsetXTop, offsetXBot, steelTopStrain, steelBotStrain;
  //console.log('XComp: '+xComp);
  //console.log('Chi: '+chi);
  if (xComp == "PurePressure") {
    offsetXTop = scalingStrain * ec2d;
    offsetXBot = scalingStrain * ec2d;
    steelTopStrain = scalingStrain * ec2d;
    steelBotStrain = scalingStrain * ec2d;
  } else if (xComp == "PureTension") {
    offsetXTop = scalingStrain * epsSmax;
    offsetXBot = scalingStrain * epsSmax;
    steelTopStrain = scalingStrain * epsSmax;
    steelBotStrain = scalingStrain * epsSmax;
    //console.log('2) SteelStrain: '+steelBotStrain);
  } else {
    offsetXTop = -chi * xComp;
    offsetXBot = chi * (heightSec - xComp);
    steelTopStrain = -(xComp - steel1.dLever) * chi;
    steelBotStrain = -(xComp - steel2.dLever) * chi;
    //console.log('3) SteelStrain: '+steelBotStrain);
  }

  let tmpStrain = new Group();
  tmpStrain.addElm(new Line([xStrain, xStrain], [0, heightSec]));
  tmpStrain.addElm(
    new Line(
      [xStrain, xStrain + offsetXTop, xStrain + offsetXBot, xStrain],
      [heightSec, heightSec, 0, 0]
    ).setColor(col.eps.getRgb())
  );
  tmpStrain.addElm(
    new Line(
      [xStrain + steelTopStrain, xStrain],
      [heightSec - steel1.dLever, heightSec - steel1.dLever]
    ).setColor(col.s.getRgb())
  );
  tmpStrain.addElm(
    new Line(
      [xStrain + steelBotStrain, xStrain],
      [heightSec - steel2.dLever, heightSec - steel2.dLever]
    ).setColor(col.s.getRgb())
  );
  if (xComp < height && xComp > 0) {
    tmpStrain.addElm(
      new DimLine(
        [xStrain, height - xComp],
        [xStrain, height],
        "x",
        1,
        -offsetVariable * 1.5,
        -offsetVariable
      )
    );
  }

  let pltStrain = tmpStrain.getPlotData();

  /***************
   *  Stress
   ***************/
  let xStress = xStrain + height / 1.1;
  let tmpStress = new Group();

  let sigmaCSupDisplay, sigmaCInfDisplay;
  let xEcTop, xEcBot;
  if (
    concBehaviour == 2 &&
    offsetXBot / scalingStrain > ec1d &&
    offsetXTop < 0
  ) {
    xEcBot = math.min(xComp, heightSec);
    xEcBot = heightSec - xEcBot;
    xEcTop =
      ((ec1d * scalingStrain - offsetXBot) / (offsetXTop - offsetXBot)) *
      heightSec;
    let ecTop = ec1d;
    let ecBot = 0;

    if (offsetXBot < 0) {
      ecBot = offsetXBot / scalingStrain;
      xEcBot = 0;
    }
    if (offsetXTop / scalingStrain > ec1d) {
      ecTop = offsetXTop / scalingStrain;
      xEcTop = heightSec;
    }
    let epsCi = math.range(ecTop, ecBot, math.abs(ecTop - ecBot) / 20);
    let xEpsCi = [];
    let sigmaCi = [];
    xEpsCi[0] = xEcBot;
    sigmaCi[0] = xStress;
    xEpsCi[1] = xEcBot;
    sigmaCi[1] = xStress + (fcdConc * sigma(ecBot)) / scalingConcStress;
    let lengthCi = epsCi._data.length;

    for (i = 2; i <= lengthCi + 1; i++) {
      xEpsCi[lengthCi - i + 3] =
        ((epsCi._data[i - 2] * scalingStrain - offsetXBot) /
          (offsetXTop - offsetXBot)) *
        heightSec;
      sigmaCi[lengthCi - i + 3] =
        xStress + (fcdConc * sigma(epsCi._data[i - 2])) / scalingConcStress;
    }
    xEpsCi[lengthCi + 2] = heightSec;
    xEpsCi[lengthCi + 3] = heightSec;

    sigmaCi[lengthCi + 2] = sigmaCi[lengthCi];
    sigmaCi[lengthCi + 3] = xStress;

    tmpStress.addElm(
      new Line(sigmaCi, xEpsCi).setColor(col.c.getRgb()).setFill(col.c.getRgb())
    );
    sigmaCSupDisplay = fcdConc * sigma(ecTop);
    sigmaCInfDisplay = fcdConc * sigma(ecBot);
  }

  if (concBehaviour == 2 && offsetXBot / scalingStrain < ec1d) {
    tmpStress.addElm(
      new Rectangle(
        fcdConc / scalingConcStress,
        heightSec,
        xStress + fcdConc / scalingConcStress / 2,
        height - heightSec / 2
      )
        .setColor(col.c.getRgb())
        .setFill(col.c.getRgb())
    );

    sigmaCSupDisplay = fcdConc;
    sigmaCInfDisplay = fcdConc;
  }

  tmpStress.addElm(
    new DimLine(
      [xStress, 0],
      [xStress, height],
      "h",
      1,
      offsetVariable * 4,
      offsetVariable
    )
  );
  tmpStress.addElm(new Line([xStress, xStress], [0, heightSec])); //Middle Line
  tmpStress.addElm(
    new Rectangle(
      offsetVariable * 2,
      heightSec,
      xStress - offsetVariable,
      height / 2
    )
      .setColor(col.c_vis.getRgb())
      .setFill(col.c_vis.getRgb())
  ); //Concrete visualisation

  if (cComp > 0 && concBehaviour != 2) {
    tmpStress.addElm(
      new Rectangle(
        fcdConc / scalingConcStress,
        cComp,
        xStress + fcdConc / scalingConcStress / 2,
        height - cComp / 2
      )
        .setColor(col.c.getRgb())
        .setFill(col.c.getRgb())
    );
  }

  let arrowScale = height / 15;
  let arrowHeadLength = arrowScale * 0.4;
  //Steel Stress Top Rebar
  if (steel1.stress < 0) {
    tmpStress.addElm(
      new Force(
        xStress,
        heightSec - steel1.dLever,
        Math.abs(steel1.stress) / scalingSteelStress + arrowHeadLength,
        0,
        arrowScale
      )
        .rotate(270, xStress, heightSec - steel1.dLever)
        .setColor(col.s.getRgb())
        .setFill(col.s.getRgb())
    );
  } else if (steel1.stress > 0) {
    tmpStress.addElm(
      new Force(
        xStress +
          Math.abs(steel1.stress) / scalingSteelStress +
          arrowHeadLength,
        heightSec - steel1.dLever,
        Math.abs(steel1.stress) / scalingSteelStress + arrowHeadLength,
        0,
        arrowScale
      )
        .rotate(
          90,
          xStress +
            Math.abs(steel1.stress) / scalingSteelStress +
            arrowHeadLength,
          heightSec - steel1.dLever
        )
        .setColor(col.s.getRgb())
        .setFill(col.s.getRgb())
    );
  }

  //Steel Stress Bottom Rebar
  if (steel2.stress < 0) {
    tmpStress.addElm(
      new Force(
        xStress,
        heightSec - steel2.dLever,
        Math.abs(steel2.stress) / scalingSteelStress + arrowHeadLength,
        0,
        arrowScale
      )
        .rotate(270, xStress, heightSec - steel2.dLever)
        .setColor(col.s.getRgb())
        .setFill(col.s.getRgb())
    );
  } else if (steel2.stress > 0) {
    let lowerArrowLength =
      Math.abs(steel2.stress) / scalingSteelStress + arrowHeadLength;
    tmpStress.addElm(
      new Force(
        xStress +
          Math.abs(steel2.stress) / scalingSteelStress +
          arrowHeadLength,
        heightSec - steel2.dLever,
        lowerArrowLength,
        0,
        arrowScale
      )
        .rotate(
          90,
          xStress +
            Math.abs(steel2.stress) / scalingSteelStress +
            arrowHeadLength,
          heightSec - steel2.dLever
        )
        .setColor(col.s.getRgb())
        .setFill(col.s.getRgb())
    );
  }

  let pltStress = tmpStress.getPlotData();

  let concStrainValue = Math.round((offsetXTop / scalingStrain) * 100) / 100;
  let steelStrainValue =
    Math.round((steelBotStrain / scalingStrain) * 100) / 100;

  //Text
  var traceText = {
    x: [
      xStrain,
      xStress,
      xStrain + offsetXTop,
      xStrain + steelBotStrain + 1,
      xStress + Math.abs(steel1.stress) / scalingSteelStress + arrowHeadLength,
      xStress + Math.abs(steel2.stress) / scalingSteelStress + arrowHeadLength,
      xStress + fcdConc / scalingConcStress,
      xStrain + steelTopStrain + 1,
      xStrain + offsetXBot + 1,
      xStress + fcdConc / scalingConcStress,
    ],
    y: [
      -2 * offsetVariable,
      -2 * offsetVariable,
      height + offsetVariable,
      heightSec - steel2.dLever + offsetVariable,
      heightSec - steel1.dLever + offsetVariable,
      heightSec - steel2.dLever + offsetVariable,
      heightSec + offsetVariable,
      heightSec - steel1.dLever + offsetVariable,
      -offsetVariable / 2,
      -offsetVariable / 2,
    ],
    mode: "text",
    text: [
      "ε",
      "σ",
      "ε<i><sub>sup</sub></i>",
      "ε<i><sub>s,inf</sub></i>",
      "σ<i><sub>s,sup</sub></i>",
      "σ<i><sub>s,inf</sub></i>",
      "σ<i><sub>sup</sub></i>",
      "ε<i><sub>s,sup</sub></i>",
      "ε<i><sub>inf</sub></i>",
      "σ<i><sub>inf</sub></i>",
    ],
  };

  let layout = {
    hovermode: false,
    //width: 400,
    height: 400,
    margin: {
      r: 0,
      l: 10,
      t: 10,
      b: 40,
    },
    xaxis: {
      range: [
        scalingStrain * ec2d - 10,
        xStress + (435 * nRebar) / scalingSteelStress + arrowHeadLength + 10,
      ],
      zeroline: false,
      showgrid: false,
      showline: false,
      showticklabels: false,
    },
    yaxis: {
      zeroline: false,
      showgrid: false,
      showline: false,
      showticklabels: false,
      scaleanchor: "x",
      scaleratio: 1,
    },
    showlegend: false,
  };

  var data = pltStrain.data;
  //data.push(... pltStrain.data);
  data.push(...pltStress.data);
  //data.push(... pltForce.data);
  data[data.length] = traceText; // Workaround. Still  needs to be improved

  if (window.checkMobile() == true) {
    layout.dragmode = false;
  }

  Plotly.react("StressesAndStrains", data, layout, config);

  // Setting html Values
  $("#epsCSup").html(Math.round((offsetXTop / scalingStrain) * 100) / 100);

  let epsCinfDisplay = offsetXBot / scalingStrain;

  $("#epsCInf").html(Math.round(epsCinfDisplay * 100) / 100);

  if (cComp > 0 && concBehaviour != 2) {
    sigmaCSupDisplay = fcdConc;
  } else if (concBehaviour != 2 && cComp == 0) {
    sigmaCSupDisplay = 0;
  } else if (concBehaviour == 2 && offsetXTop > 0) {
    sigmaCSupDisplay = 0;
    sigmaCInfDisplay = 0;
  }

  if (cComp == height && concBehaviour != 2) {
    sigmaCSupDisplay = fcdConc;
    sigmaCInfDisplay = fcdConc;
  } else if (concBehaviour != 2) {
    sigmaCInfDisplay = 0;
  }
  $("#sigCSup").html(Math.round(sigmaCSupDisplay * 10) / 10);
  $("#sigCInf").html(Math.round(sigmaCInfDisplay * 10) / 10);

  $("#epsSsup").html(Math.round((steelTopStrain / scalingStrain) * 100) / 100);
  $("#sigSsup").html(Math.round(steel1.stress / nRebar));
  $("#epsSinf").html(Math.round((steelBotStrain / scalingStrain) * 100) / 100);
  $("#sigSinf").html(Math.round(steel2.stress / nRebar));
}

/************************
 * Find coresbonding Chi
 * @param (number) N  Current Normal Force
 ************************/

function chatchI(N) {
  let chiCatch,
    xCatch,
    NTopCatch,
    NBotCatch,
    MdCatch,
    NdCatch,
    cCatch,
    slopeCatch;
  let j = 2 * resolution - 2;
  Nd[-1] = -10000000000;
  if (concBehaviour == 3) {
    let positionHand;
    let iHand;
    // console.log(N);
    for (i = 0; i < 5; i++) {
      if (Math.abs(N - Nhand[i]) < 10) {
        positionHand = position[i];
        iHand = i;
        // console.log(positionHand);
      }
      // console.log(Nhand[i]);
    }
    xCatch = x[positionHand];
    NTopCatch = NsTop[positionHand];
    NBotCatch = NsBot[positionHand];
    NdCatch = Nhand[iHand];
    MdCatch = Mhand[iHand];
    cCatch = c[positionHand];
    if (positionHand < resolution) {
      chiCatch = Xi1._data[positionHand];
    } else {
      chiCatch = Xi1._data[2 * resolution - 1 - positionHand];
    }
  } else {
    for (let i = 0; i < Md.length; i++) {
      if (Nd[i - 1] < N && N <= Nd[i]) {
        // console.log(Nd[i-1]+' Forces '+Nd[i]);
        xCatch = x[i];
        // console.log(xCatch);
        if (Nd[i] == Nd[2 * resolution - 2]) {
          xCatch = "PureTension";
        }
        //console.log('xCatch: '+xCatch);
        NTopCatch = NsTop[i];
        NBotCatch = NsBot[i];
        // console.log(NTopCatch/1000);
        // console.log(NBotCatch/1000);

        if (xCatch == "PurePressure") {
          NdCatch = Nd[0];
          MdCatch = Md[0];
        } else if (xCatch == "PureTension") {
          NdCatch = Nd[2 * resolution - 2];
          MdCatch = Md[2 * resolution - 2];
        } else {
          slopeCatch = (Nd[i] - Nd[i - 1]) / (Md[i] - Md[i - 1]);
          MdCatch = Md[i - 1] + (N - Nd[i - 1]) / slopeCatch;
          NdCatch = N;
        }

        // No interpolation
        let interpolation = false;
        if (!interpolation) {
          NdCatch = Nd[i];
          MdCatch = Md[i];
        }
        cCatch = c[i];
        if (i < resolution) {
          chiCatch = Xi1._data[i];
        } else {
          chiCatch = Xi1._data[j];
        }
        break;
      }
      j--;
    }
  }
  return [chiCatch, xCatch, NTopCatch, NBotCatch, MdCatch, NdCatch, cCatch];
}

function updateStressStrain(NCatch) {
  //console.log('UpdatingStressStrain with: '+NCatch);
  let catchThem = chatchI(NCatch);
  steelTop.diameter = dRebar;
  steelBot.diameter = dRebar;
  steelTop.As = (Math.pow(steelTop.diameter, 2) * Math.PI) / 4;
  steelBot.As = (Math.pow(steelBot.diameter, 2) * Math.PI) / 4;
  steelTop.dLever = dTop;
  steelBot.dLever = dBot;
  steelTop.stress = catchThem[2] / steelTop.As;
  steelBot.stress = catchThem[3] / steelBot.As;
  // console.log('CoughtN: '+NCatch+' X: '+catchThem[1]);
  let xDisplay;
  if (catchThem[1] > height || catchThem[1] == "PurePressure") {
    xDisplay = height;
  } else if (catchThem[1] < 0 || catchThem[1] == "PureTension") {
    xDisplay = 0;
  } else {
    xDisplay = catchThem[1];
  }
  $("#mom").html(Math.round(catchThem[4]));
  $("#normalForce").html(Math.round(catchThem[5]));
  $("#x").html(Math.round(xDisplay));
  $("#chi").html(Math.round(catchThem[0] * 10000) / 10 + " · 10<sup>-6</sup>");
  plotStressStrain(
    height,
    steelTop,
    steelBot,
    catchThem[0],
    catchThem[1],
    catchThem[6],
    fcd,
    NCatch
  );
  updatePoint(catchThem[5], catchThem[4]);
}

/*********************
 *  Updating Slider
 *********************/
function updateSlider(values, handle, unencoded, tap, positions) {
  let NCatch = values[0];
  //console.log(NCatch)
  updateStressStrain(NCatch);
}

/***************************************************************
 *  Calculations with SIA 262 Formula for compressive stresses
 ***************************************************************/
let zeta, kSigma;

function sigma(epsC) {
  zeta = epsC / ec1d;
  kSigma = (Ec * 1000) / 400 / fcd;
  return (kSigma * zeta - Math.pow(zeta, 2)) / (1 + (kSigma - 2) * zeta); //Formula from SIA 262 (28)
}

function concreteSIA262(epsCStart, epsCEnd) {
  let sigmaC = [];
  let epsRunC = [];

  let stepSize = (epsCEnd - epsCStart) / 100;
  // Calculation of the mass center
  let Atot = 0;
  let AxStot = 0;
  let dAdxS;
  let dA;

  for (let i = 0; i <= 100; i++) {
    epsRunC[i] = epsCStart + i * stepSize;
    sigmaC[i] = fcd * sigma(epsRunC[i]);
    dA = stepSize * sigmaC[i];
    dAdxS = (epsCStart + (i + 0.5) * stepSize) * dA;
    Atot += dA;
    AxStot += dAdxS;
  }

  let epsCcenter = AxStot / Atot;

  return [Atot * width, epsCcenter];
}

/******************
 *      Main
 ******************/
mnInteraktionDetailed(true);

plotStressStrain(
  height,
  steelTop,
  steelBot,
  Xi1._data[0],
  x[0],
  c[0],
  fcd,
  Nd[0]
);

//forceSlider.noUiSlider.on('set', updateSlider);
if (window.checkMobile() == true) {
  forceSlider.noUiSlider.on("set", updateSlider);
} else {
  forceSlider.noUiSlider.on("update", updateSlider);
}
